import React, { useEffect, useState } from 'react';

import * as Yup from 'yup';
import { Formik, Field, Form } from 'formik';
import { Alert, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import { UpwardLoadingButton } from 'ui';
import { EmailInput, PasswordInput } from 'ui-blocks/form-elements';
import { loginUserSuccessPartner } from 'redux/auth/authActions';
import { useLocation } from 'react-router-dom';
import { emailSignInJobcase, emailSignInJobcaseProxy } from '../services/authPartners';
import { getLoginErrorMessage } from '../loginErrorMessage';

const getIsInternational = (location) => location?.pathname?.toLocaleLowerCase()?.includes('intl');

const SignInForm = (props) => {
   const [errorMessage, setErrorMessage] = useState();
   const location = useLocation();

   // It is an international log-in page if the url path is '/auth/login/jobcase-intl'
   const [isInternational, setIsInternational] = useState(getIsInternational(location));

   useEffect(() => {
      setIsInternational(getIsInternational(location));
   }, [location?.pathname]);

   const handleSignInResponse = (setSubmitting) => (res = {}) => {
      if (res?.token) {
         props?.loginUserSuccessPartner({
            token: res?.token,
         });
      } else {
         setErrorMessage(getLoginErrorMessage(res?.status));
         setSubmitting(false);
      }
   };

   return (
      <Formik
         initialValues={ {
            email: '',
            password: '',
            rememberMe: true,
         } }
         validateOnChange={ false }
         validateOnBlur={ false }
         validationSchema={ Yup.object({
            email: Yup.string()
               .email()
               .required(),
            password: Yup.string()
               .required(),
            rememberMe: Yup.bool(),
         }) }
         onSubmit={ (values, { setSubmitting }) => {
            setErrorMessage(undefined);

            if (isInternational) {
               emailSignInJobcaseProxy(values?.email, values?.password).subscribe(
                  handleSignInResponse(setSubmitting),
               );
            } else {
               emailSignInJobcase(values?.email, values?.password).subscribe(
                  handleSignInResponse(setSubmitting),
               );
            }
         } }
      >
         {
            (formik) => {
               return (
                  <Form
                     style={{
                        color: '#262626 important!',
                        fontFamily: 'Inter, Arial, sans-serif',
                     }}
                  >
                     {
                        errorMessage
                        && (
                           <Alert
                              color='danger'
                              className='d-flex align-items-start'
                              style={ {
                                 backgroundColor: '#FDECEC',
                                 color: '#B42318',
                                 border: '1px solid #F3C0C0',
                                 borderRadius: '8px',
                                 fontSize: '14px',
                                 lineHeight: '1.4',
                                 padding: '12px 14px',
                              } }
                           >
                              <i
                                 className='fas fa-exclamation-circle mr-2'
                                 aria-hidden='true'
                                 style={ { color: '#D92D20', marginTop: '2px' } }
                              />
                              <span>{ errorMessage }</span>
                           </Alert>
                        )
                     }
                     <FormGroup>
                        <Field
                           name='email'
                           component={ EmailInput }
                           placeholder='Email Address *'
                           bsSize='lg'
                        />
                     </FormGroup>
                     <FormGroup>
                        <Field
                           name='password'
                           bsSize='lg'
                           placeholder='Password *'
                           component={ PasswordInput }
                           style={{
                              borderRadius: '4px',
                           }}
                        />
                     </FormGroup>
                     <div className='text-center mt-4'>
                        <UpwardLoadingButton
                           type='submit'
                           color='primary'
                           size='lg'
                           block
                           className='w-100'
                           style={{
                              fontFamily: 'Inter-SemiBold',
                              backgroundColor: '#2C04BD',
                              borderColor: 'transparent',
                              height: '50px',
                              fontWeight: '400',
                           }}
                           isLoading={ formik.isSubmitting }
                        >
                           Log in
                        </UpwardLoadingButton>
                     </div>
                  </Form>
               );
            }
         }
      </Formik>
   );
};

const mapDispatchToProps = (dispatch) => ({
   loginUserSuccessPartner: (data) => (dispatch(loginUserSuccessPartner(data))),
});

export default connect(
   null,
   mapDispatchToProps,
)(SignInForm);
